<div class="user-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a routerLink="/utilisateur/codes" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour au tableau de bord codes</a>
      <span class="crumb-current">Identification</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Sécurité</p>
        <h1>Vérification d'identité</h1>
        <p class="lead">Ajoutez votre photo de profil et les deux faces de votre CNI pour sécuriser votre compte.</p>
      </div>
    </div>
  </div>

  <div class="accordion" id="idAccordion">
    <div class="accordion-item card-glass">
      <h2 class="accordion-header" id="headingOne">
        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
          Procédure d'identification
        </button>
      </h2>
      <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#idAccordion">
        <div class="accordion-body">
          <p class="card-text">Identification personne majeure</p>
          <ul>
            <li>Ajoutez une photo de profil nette.</li>
            <li>Transmettez les photos des deux faces de votre CNI.</li>
            <li>La confirmation du numéro par SMS est temporairement suspendue.</li>
            <li>Nos équipes comparent les pièces envoyées et valident votre identité.</li>
          </ul>
        </div>
      </div>
    </div>

    <div class="accordion-item card-glass">
      <h2 class="accordion-header" id="headingTwo">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
          Pièces d'identification
        </button>
      </h2>
      <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#idAccordion">
        <div class="accordion-body">
          <p *ngIf="uploadMessage" class="alert-text success">{{uploadMessage}}</p>
          <p *ngIf="uploadError" class="alert-text danger">{{uploadError}}</p>

          <div class="row g-3">
            <div class="col-lg-4 col-md-6">
              <div class="upload-card">
                <h5>Photo de profil</h5>
                <input type="file" accept="image/*" class="form-control mb-2" (change)="onDocumentSelected($event, 'profile')">
                <small class="file-label" *ngIf="selectedProfileName">{{selectedProfileName}}</small>
                <button type="button" class="btn btn-primary btn-pill mt-2" [disabled]="!selectedProfileFile || loader" (click)="uploadProfile()">
                  Envoyer
                </button>
              </div>
            </div>

            <div class="col-lg-4 col-md-6">
              <div class="upload-card">
                <h5>CNI Recto</h5>
                <input type="file" accept="image/*" class="form-control mb-2" (change)="onDocumentSelected($event, 'recto')">
                <small class="file-label" *ngIf="selectedRectoName">{{selectedRectoName}}</small>
                <button type="button" class="btn btn-primary btn-pill mt-2" [disabled]="!selectedRectoFile || loader" (click)="uploadRecto()">
                  Envoyer
                </button>
              </div>
            </div>

            <div class="col-lg-4 col-md-6">
              <div class="upload-card">
                <h5>CNI Verso</h5>
                <input type="file" accept="image/*" class="form-control mb-2" (change)="onDocumentSelected($event, 'verso')">
                <small class="file-label" *ngIf="selectedVersoName">{{selectedVersoName}}</small>
                <button type="button" class="btn btn-primary btn-pill mt-2" [disabled]="!selectedVersoFile || loader" (click)="uploadVerso()">
                  Envoyer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="accordion-item card-glass">
      <h2 class="accordion-header" id="headingFour">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour" (click)="afficher()">
          Mes documents
        </button>
      </h2>
      <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#idAccordion">
        <div class="accordion-body">
          <div class="row g-3">
            <div class="col-md-6" *ngIf="urlProfile">
              <img class="doc-img" [src]="urlProfile" alt="Photo de profil">
            </div>
            <div class="col-md-6" *ngIf="urlRecto">
              <img class="doc-img" [src]="urlRecto" alt="Recto CNI">
            </div>
            <div class="col-md-6" *ngIf="urlVerso">
              <img class="doc-img" [src]="urlVerso" alt="Verso CNI">
            </div>
            <div class="col-md-6" *ngIf="urlVersoMineur">
              <img class="doc-img" [src]="urlVersoMineur" alt="Document représentant">
            </div>
            <div class="col-md-6" *ngIf="urlRectoMineur">
              <img class="doc-img" [src]="urlRectoMineur" alt="Document identité">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
